// extracted by mini-css-extract-plugin
export default {"container":"ListDiff_container__nhQ-C","item":"ListDiff_item__H5Y7N","green":"ListDiff_green__X8c2e","red":"ListDiff_red__rKWrG"};